export default __webpack_public_path__ + "static/media/female-scientist-illustration.0f02bb99.jpg";